import BaseSetup from '@/components/BaseSetup';
import OrganizationCompanyDetailedEntity from '@/entity/organization-company/OrganizationCompanyDetailedEntity';
import OrganizationCompanyListItemEntity from '@/entity/organization-company/OrganizationCompanyListItemEntity';
import { useCompanyService } from '@/services/company/CompanyService';

export type SharedLogoCompanyEmits = {};

export type SharedLogoCompanyProps = {
	isClientCompany?: boolean
	showLogoUpdate?: boolean
	company: { name?: string, id: number }
	  | OrganizationCompanyListItemEntity
	  | OrganizationCompanyDetailedEntity
};

export default class SharedLogoCompanySetup extends BaseSetup {

	static readonly defaultProps = {};

	constructor (
		private props: SharedLogoCompanyProps,
		private emits: SharedLogoCompanyEmits,
	) {
		super();
	}

	get logoUrl () { return this.props.company.id }
	get canUpdateLogo () { return this.props.showLogoUpdate && this.self.isAgency() && this.self.can('CompanyLogo') && !this.self.suiteUserId }

	async updateLogoAsync () {
		if (this.props.company instanceof OrganizationCompanyListItemEntity
		  || this.props.company instanceof OrganizationCompanyDetailedEntity) {
			await useCompanyService(this.props.company).promptLogoModalAsync(this.props.company.id, this.props.company.logoId);
		}
	}

}
